module.exports = __webpack_public_path__ + "static/ochre_jelly-9d2d4a208dce4820c71c1f46d9e92479.jpg";